import { PencilIcon } from '@heroicons/react/24/outline';

const EditIconButton = ({ size, onClick }: { size: string; onClick: () => void }) => {
  return (
    <div
      className={`shadow-2xl bg-gray-100 text-blue-500 flex justify-center items-center p-2 rounded-full hover:bg-gray-300 cursor-pointer transition duration-300 ease-in-out ${size}`}
      onClick={onClick}
    >
      <PencilIcon className='h-5 w-5' />
    </div>
  );
};

export default EditIconButton;
